import { cloneDeep, intersection, orderBy } from 'lodash';

export default function (data) {
  let containerData = []; // Tao ra arr de chua tat ca du lieu cua dat
  const nameArr = [];
  for (let i = 0; i < data.length; i++) {
    nameArr.push(data[i].name);
    for (let key in data[i].data) {
      const newData = { date: key, [data[i].name]: data[i].data[key] }; // Tao ra kieu du lieu {data:'', value:''} de chut de convert
      containerData.push(newData);
    }
  }

  const handleDatas = (data) => {
    // bat dau lay du lieu di xu ly tiep
    let resultData = []; // Day la arr chua tat ca ket qua cuoi cung
    let arrPosition = []; // Nay la arr dung de chua nhung gia tri data.date ma da lam roi , no se so sanh va giup khong lam lap lai nhung cai gia tri do nua

    for (let i = 0; i < data.length; i++) {
      let flag = 1; // Nay la flag dung de xem cai data arrPosition[i] do da duoc lam chua. neu chua duoc thi thuc hien con khong thi bo lam cai tiep theo
      for (let k = 0; k < arrPosition.length; k++) {
        // eslint-disable-next-line
        if (data[i].date == arrPosition[k].date) {
          flag = 0;
          break;
        }
      }

      if (flag === 1) {
        let value = []; // Bien nay la dung de chua tat ca cac du lieu kieu  {data:'', value''} cua toan bo data
        let numberValue = Object.assign({}, {}); // Xem phia duoi cai nay la 1 hinh thuc thay doi gia tri key khi push thoi

        arrPosition.push({ date: data[i].date });

        for (let j = i; j < data.length; j++) {
          const _name = intersection(Object.keys(data[j]), nameArr)[0];
          if (data[i].date === data[j].date) {
            if (data[j][_name]) {
              numberValue[_name] = data[j][_name]; // Cai nay la minh tao ra ket qua nhu la {value0 : '12345'} - {value1: '22345}  lam kieu nay no moi cho cai key khi push vo arr no moi thay doi duoc
              value.push(numberValue);
              numberValue = Object.assign({}, {});
            }
          }
        }

        resultData.push({ date: data[i].date }); // Nay la push date cua data[i].date vao
        for (let k = 0; k < value.length; k++) {
          // Cho chay vong lap cua value duoc tim thay o tren nghia la no se nhu vay => {value0: '123', value1: '234', value2: '345'}
          Object.entries(value[k]).forEach(([key, value]) => {
            resultData[i][key] = value;
          }); // Sau do thuc hien ham nay de cho no push value[k] cua obj value -> vao resultData[i]
        }
      }
    }
    return resultData;
  };
  const result = cloneDeep(
    orderBy(handleDatas(containerData), ['date'], ['asc']),
  );
  result.map((r) => (r.date = new Date(r.date)));
  return [nameArr, result];
}
